import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { imageBaseurl, apiBaseUrl } from "../utils/common";
import ShareDialog from "../components/ShareButton";
import {
  ArrowLeft,
  Heart,
  Share2,
} from "lucide-react";

const BlogDetails = () => {
  const { slug } = useParams();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(0);

  // Fetch Blog Details
  useEffect(() => {
    if (slug) {
      fetchPost();
    }
  }, [slug]);

  // Like Blog
  const handleLike  = async () => {
    
    if (!liked) {
      const response = await fetch(
        `${apiBaseUrl}/public/blog/like/${slug}`
      );
      setLiked(!liked);
      setLikes((prev) => prev + 1);
    }
  };

  const fetchPost = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${apiBaseUrl}/public/blog/${slug}`
      );

      const data = await response.json();

      setPost(data?.data || null);
      setLikes(data?.data?.liked || 0);

    } catch (error) {
      console.error("Error fetching post:", error);
    } finally {
      setLoading(false);
    }
  };

  // Loading State
  if (loading) {
    return (
      <div className="text-center py-20">
        Loading...
      </div>
    );
  }

  // No Blog Found
  if (!post) {
    return (
      <div className="text-center py-20">
        Blogs not found
      </div>
    );
  }

  const imageUrl = post.image
    ? `${imageBaseurl}${post.image}`
    : "";

  return (
    <>

      <div className="blogs-section py-16">
        <div className="container mx-auto px-4">

          <article className="max-w-4xl mx-auto">

            {/* Header */}
            <header className="mb-10">
              <div className="flex items-center justify-between gap-4 flex-wrap mb-6">

                <Link
                  to="/newses"
                  className="inline-flex items-center gap-2 text-sm mb-6 hover:opacity-80"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Back to News
                </Link>
                {/* Actions */}
                <div className="flex items-center gap-3">

                  {/* Like Button */}
                  <button
                    onClick={handleLike}
                    className={`flex items-center gap-2 px-4 py-2 rounded-full border transition-all duration-300
                    ${liked
                        ? "bg-red-500 text-white border-red-500"
                        : "bg-white text-black border-gray-300"
                      }`}
                  >
                    <Heart
                      className={`w-4 h-4 ${liked ? "fill-white" : ""
                        }`}
                    />

                    <span>{likes}</span>
                  </button>

                  {/* Share Button */}
                 <ShareDialog productName={post.title} />

                </div>

              </div>
              <h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight">
                {post.title}
              </h1>

              {/* <p className="text-gray-500 text-sm md:text-base">
                By {post.author} | Published:{" "}
                {post.createdAt
                  ? new Date(post.createdAt).toLocaleDateString(
                      "en-IN",
                      {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      }
                    )
                  : ""}
              </p> */}

            </header>

            {/* Body */}
            <div className="blog-details-body">

              {/* Image */}
              {post.image && (
                <img
                  src={imageUrl}
                  alt={post.title}
                  className="w-full rounded-2xl mb-8 object-cover max-h-[500px]"
                />
              )}

              {/* Content */}
              <div
                className="prose prose-lg max-w-none"
                dangerouslySetInnerHTML={{
                  __html: post.des,
                }}
              />

            </div>

            {/* Footer */}
            <footer className="mt-12 border-t pt-6 text-sm text-gray-600 space-y-2">

              {/* <p>
                <strong>Category:</strong>{" "}
                {post.category}
              </p>

              <p>
                <strong>Tags:</strong>{" "}
                {post.tags}
              </p> */}

              <p>
                <strong>Last Updated:</strong>{" "}
                {post.updatedAt
                  ? new Date(post.updatedAt).toLocaleDateString(
                    "en-IN",
                    {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    }
                  )
                  : ""}
              </p>

            </footer>

          </article>

        </div>
      </div>
    </>
  );
};

export default BlogDetails;